"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CHC = function CHC(props) {
  var size = props.size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    preserveAspectRatio: "xMidYMid slice",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m130.001 199.996c0-82.864 67.136-150 150-150s150 67.136 150 150c0 82.862-67.136 150.007-150 150.007s-150-67.145-150-150.007z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m139.758 199.525c0-77.381 62.862-140.24 140.243-140.24s140.243 62.859 140.243 140.24-62.862 140.226-140.243 140.226c-77.614 0-140.243-62.845-140.243-140.226z",
    fill: "#0e3386"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m280.001 303.099c57.143 0 103.571-46.429 103.571-103.571 0-57.143-46.429-103.571-103.571-103.571-57.143 0-103.571 46.429-103.571 103.571 0 57.143 46.195 103.571 103.571 103.571z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m280.005 108.562c-50.234 0-90.947 40.715-90.947 90.966 0 50.237 40.713 90.942 90.947 90.942 29.763 0 55.954-14.281 72.621-36.179l-27.148-25.484c-9.76 15.007-26.424 25-45.708 25-29.998 0-54.294-24.281-54.294-54.28.236-30.013 24.531-54.294 54.53-54.294 19.767 0 36.906 10.481 46.43 26.191l26.66-25.958c-16.667-22.384-43.094-36.906-73.09-36.906zm-16.198 66.906v32.87c0 4.529-6.893 4.529-6.893 0v-32.865h-16.434v32.391c0 10.714 2.619 15.715 10.481 15.715h16.9c9.524 0 12.374-2.869 12.374-14.774v-33.334h-16.429v-.002zm22.381 0v48.108h25.722c9.038 0 13.803-1.679 13.803-12.393 0-4.041-.005-8.803-4.514-11.417 3.319-1.676 4.514-4.762 4.514-10.714 0-11.2-4.043-13.584-13.803-13.584zm57.144 0c-7.143 0-11.181 2.869-11.417 11.203-.25 8.333 0 4.76 0 7.845 0 3.102-.488 10.012 9.036 10.012h11.905c3.338 0 2.619 4.041 2.619 4.041v2.614c0 2.867-5.702 2.869-6.893.721-.955-1.426-.488-4.041-.488-4.041h-16.179c0 3.319-1.91 15.946 8.083 15.946 8.584-.236 18.346-.233 18.346-.233 8.803 0 13.329-2.379 13.329-10.245v-10.714c0-5.717-4.041-9.291-9.757-9.291h-11.672c-3.102 0-2.381-4.512-2.381-5.952 0-2.129 6.672-2.85 6.672.721v2.148h17.369c0-11.2-2.143-14.774-13.326-14.774h-15.246zm-39.989 11.203c4.998 0 6.893-.002 6.893 1.893v2.633c0 2.381-4.041 2.129-6.893 2.129zm3.005 19.479c2.491-.019 2.936.162 3.652 1.948.233.469 0 1.893 0 2.614 0 2.381-3.336 2.15-6.907 2.15v-6.674c1.371 0 2.426-.031 3.255-.038z",
    fill: "#cc3433"
  }));
};

CHC.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
CHC.defaultProps = {
  size: '100'
};
var _default = CHC;
exports["default"] = _default;